import DifficultyEasy from '@alltrails/denali/icons/DifficultyEasy';
import DifficultyModerate from '@alltrails/denali/icons/DifficultyModerate';
import DifficultyHard from '@alltrails/denali/icons/DifficultyHard';
import DifficultyStrenuous from '@alltrails/denali/icons/DifficultyStrenuous';

type DifficultyIconProps = {
  difficulty?: number;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
};

/**
 * Difficulty icon component that displays the icon based on difficulty rating
 *
 * @param {number} difficulty - The difficulty rating (1-8)
 * @param {string} size - Icon size (default: 'xs')
 * @returns JSX element with the difficulty icon or null
 */
export const DifficultyIcon = ({ difficulty, size = 'xs' }: DifficultyIconProps) => {
  if (!difficulty) {
    return null;
  }

  if ([1, 2].includes(difficulty)) {
    return <DifficultyEasy size={size} color="--color-difficulty-easy" />;
  }

  if ([3, 4].includes(difficulty)) {
    return <DifficultyModerate size={size} color="--color-difficulty-moderate" />;
  }

  if ([5, 6].includes(difficulty)) {
    return <DifficultyHard size={size} color="--color-difficulty-hard" />;
  }

  if ([7, 8].includes(difficulty)) {
    return <DifficultyStrenuous size={size} color="--color-difficulty-strenuous" />;
  }

  return null;
};

export default DifficultyIcon;
